module.exports = __webpack_public_path__ + "components/media-kit/static/article-desktop-6a20ab5235f0b88db597bb662e32818d.png";